var _style, _path, _g, _defs, _defs2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLdlLevels({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3A28A;}\n\t.st1{fill:#E6393D;}\n\t.st2{clip-path:url(#SVGID_3_);}\n\t.st3{clip-path:url(#SVGID_4_);fill:#AA1917;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,183.6c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.4,149.2,63.2,183.6,106,183.6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.7,53.9c-0.3,0.5-0.5,0.7-0.7,1c-10,15.5-20.1,31.1-30.1,46.6c-3.1,4.8-4.8,10.2-5.2,15.9 c-1.9,22.9,17.6,41.6,40.4,38.9c26.4-3.1,40.4-33.2,25.9-55.5c-3.5-5.4-7-10.9-10.5-16.3C119.9,74.4,113.4,64.3,106.7,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.7,53.9c6.7,10.3,13.2,20.4,19.8,30.5c3.5,5.4,7,10.9,10.5,16.3c14.5,22.3,0.5,52.3-25.9,55.5 c-22.8,2.7-42.3-15.9-40.4-38.9c0.5-5.7,2.1-11.1,5.2-15.9c10-15.6,20.1-31.1,30.1-46.6C106.2,54.6,106.3,54.4,106.7,53.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M106.7,53.9c-0.3,0.5-0.5,0.7-0.7,1c-10,15.5-20.1,31.1-30.1,46.6c-3.1,4.8-4.8,10.2-5.2,15.9 c-1.9,22.9,17.6,41.6,40.4,38.9c26.4-3.1,40.4-33.2,25.9-55.5c-3.5-5.4-7-10.9-10.5-16.3C119.9,74.4,113.4,64.3,106.7,53.9z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_2_",
    d: "M106.7,53.9c6.7,10.3,13.2,20.4,19.8,30.5c3.5,5.4,7,10.9,10.5,16.3c14.5,22.3,0.5,52.3-25.9,55.5 c-22.8,2.7-42.3-15.9-40.4-38.9c0.5-5.7,2.1-11.1,5.2-15.9c10-15.6,20.1-31.1,30.1-46.6C106.2,54.6,106.3,54.4,106.7,53.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 116.1,
    className: "st3",
    width: 95.9,
    height: 48.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdlLevels);
export default __webpack_public_path__ + "static/media/LDL_Levels.46db504786954e0a480aed91ccf03f47.svg";
export { ForwardRef as ReactComponent };